import gsap from 'gsap';
import { getCurrentDevice } from '../utils';

export class Masonry {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.options = options;
		this.devices = options.devices || [ 'Desktop', 'Tablet', 'Mobile' ];
		this.isEnable = false;
		this.currentDevice = getCurrentDevice();
		this.timer = null;
		this.init();
	}

	init() {
		if ( this._initBound ) return;
		this._initBound = true;
		if ( ! this.elements.length || ! this.devices.length ) return;
		window.addEventListener( 'DOMContentLoaded', () => {
			if ( this.options.devices.includes( this.currentDevice ) ) {
				this.execute();
			}
		} );
		this.resize();
	}

	execute() {
		this.elements.forEach( ( container ) => {
			const theInner = container.querySelector( '.inner' );
			const computedStyles = window.getComputedStyle( theInner );
			const columnGap = computedStyles.columnGap
				? parseFloat( computedStyles.columnGap )
				: 0;
			const rowGap = computedStyles.rowGap
				? parseFloat( computedStyles.rowGap )
				: 0;
			const totalWidth = theInner.offsetWidth;
			const minWidth = this.options.minWidth || 350;
			let columns = 0;
			let theWidth = 0;
			while ( theWidth < totalWidth ) {
				theWidth += minWidth;
				if ( theWidth < totalWidth ) {
					theWidth += columnGap;
				}
				if ( theWidth < totalWidth ) {
					columns++;
				}
			}
			theInner.classList.add( 'is-masonry' );
			if ( columns < 2 ) return;
			const allItems = gsap.utils.toArray( '*>.el-item', container );

			// Get width
			const itemWidth =
				Math.round(
					( ( totalWidth - columnGap * ( columns - 1 ) ) /
						totalWidth /
						columns ) *
						100000
				) /
					1000 +
				'%';

			// Set styles
			const countArray = [];
			const heightArray = [];
			for ( let i = 0; i < columns; i++ ) {
				countArray[ i ] = 0;
				heightArray[ i ] = 0;
			}

			allItems.forEach( ( item, index ) => {
				item.style = `width:${ itemWidth };`;
				let theColumn = 0;
				if ( index < columns ) {
					theColumn = index % columns;
				} else {
					theColumn = heightArray.findIndex(
						( ele ) => ele === Math.min( ...heightArray )
					);
				}
				item.style = `width:${ itemWidth };order:${ theColumn + 1 }`;
				const oldCount = countArray[ theColumn ];
				const oldHeight = heightArray[ theColumn ];
				countArray[ theColumn ] = oldCount + 1;
				heightArray[ theColumn ] = oldHeight + item.offsetHeight;
			} );
			const maxIndex = heightArray.findIndex(
				( item ) => item === Math.max( ...heightArray )
			);
			const count = countArray[ maxIndex ];
			const rootHeight = Math.max( ...heightArray ) + rowGap * count;
			theInner.style = `height:${ rootHeight }px`;
		} );
		this.isEnable = true;
	}

	destroy() {
		this.elements.forEach( ( container ) => {
			container.style = '';
			container.classList.remove( 'is-masonry' );
			const allItems = gsap.utils.toArray( '*>.el-item', container );
			allItems.forEach( ( item ) => ( item.style = '' ) );
		} );
		this.isEnable = false;
	}

	resize() {
		window.addEventListener( 'resize', () => {
			this.timer?.kill();
			this.timer = gsap.delayedCall( 0.1, () => {
				this.currentDevice = getCurrentDevice();
				if ( this.isEnable ) {
					this.destroy();
				}
				if ( this.devices.includes( this.currentDevice ) ) {
					this.execute();
				}
			} );
		} );
	}
}
